import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './meal.component.html',
    styleUrls: ['./meal.component.css'],
})

export class MealComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit() {
  }
}
